import { Api } from './../api/api';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EventInfoProvider {
    constructor(public http: HttpClient, private api: Api) { }

    adminEventList: any = [];

    getSpeakers(pin): Observable<any> {
        return this.http.get('assets/json/' + pin + '.json');
    }
    getSpeakersList(): Observable<any> {
        return this.http.get('assets/json/speakers.json');
    }
    getSeeItList(): Observable<any> {
        return this.http.get('assets/json/seeIt.json');
    }
    getEventInfo(eventId: string): Observable<any> {
        return this.api.get(`/event-info/${eventId}`)
            .map(res => {
                return res;
            });
    }

    isAdmin(eventUuid: string) {
      let elem = this.adminEventList.find(e => e.uuid == eventUuid);
      return !!elem;
    }

    async myEventAdminList(): Promise<any> {
        return await this.api.get(`events/adminMyEvents?pastCurrentUpcoming=&published=${true}`, {}).toPromise();
    }

    myEventAdminListObs() {
      return this.api.get(`events/adminMyEvents?pastCurrentUpcoming=&published=${true}`, {}).map(res => {
        this.adminEventList = res;
        return res
      });
    }
}



// WEBPACK FOOTER //
// ./src/providers/event-info/event-info.ts